import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CoverageAppState from '../interfaces/CoverageAppState';
import { actionCreators } from '../redux/actions';
import { createPortal } from 'react-dom';

const Tooltip = () => {
  const dispatch = useDispatch();
  const display = useSelector((state: CoverageAppState) => state.displayTooltip)

  const toggleTooltip = () => dispatch(actionCreators.toggleTooltip());
  const autoHide = () => display && toggleTooltip();

  let tooltipStyle = { top: 170, right: 100, position:'fixed'};
  let renderContainer =  document.body;
  const bookmarkTooltipRenderContainer = document.getElementById("watch-tooltip-container");
  if(bookmarkTooltipRenderContainer){
      renderContainer = bookmarkTooltipRenderContainer;
      tooltipStyle = {};
  }

  
  useEffect(() => {
    display && setTimeout(autoHide, 3000);
  }, [display]);
  
  return (
    createPortal(
      <>
        {display && (
          <div className="bookmarks__tooltip" style={tooltipStyle}>
            <label>Bevakning sparad</label>
          </div>
        )}
      </>,
      renderContainer
    )
  )
}

export default Tooltip;